import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Table, Tag, Typography, Spin } from "antd";
import { CopyOutlined } from "@ant-design/icons";
import { message } from "antd";

const { Text } = Typography;

const BarcodeTable = ({
  data,
  loading,
  pagination,
  onPaginationChange,
  callReFetch,
  dispatch,
}) => {
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);

  // Detect window size for mobile view
  useEffect(() => {
    const handleResize = () => setIsMobileView(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleCopyBarcode = (barcode) => {
    navigator.clipboard
      .writeText(barcode)
      .then(() => {
        message.success("Barcode copied to clipboard!");
      })
      .catch(() => {
        message.error("Failed to copy barcode");
      });
  };

  const handleTableOnChange = (pagination, filteredInfo, sorter) => {
    if (dispatch) {
      dispatch({ type: "sorter", payload: sorter });
      dispatch({ type: "filteredInfo", payload: filteredInfo });
    }
    if (callReFetch) {
      callReFetch();
    }
  };

  const columns = [
    {
      title: "Article Name",
      dataIndex: "name",
      key: "name",
      width: 200,
      fixed: "left",
      sorter: true,
      render: (text) => <Text strong>{text}</Text>,
    },
    {
      title: "Brand",
      dataIndex: "brand",
      key: "brand",
      width: 120,
      sorter: true,
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      width: 120,
      sorter: true,
    },
    {
      title: "Subcategory",
      dataIndex: "subcategory",
      key: "subcategory",
      width: 120,
      sorter: true,
    },
    {
      title: "Division",
      dataIndex: "division",
      key: "division",
      width: 120,
      sorter: true,
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      width: 120,
      sorter: true,
    },
    {
      title: "HPP",
      dataIndex: "hpp",
      key: "hpp",
      width: 100,
      sorter: true,
      render: (value) => <Text>Rp. {value?.toLocaleString() || 0}</Text>,
    },
    {
      title: "Color",
      dataIndex: "colorName",
      key: "colorName",
      width: 120,
      sorter: true,
      render: (text) => (
        <Tag color="blue" style={{ margin: 0 }}>
          {text || "No Color"}
        </Tag>
      ),
    },
    {
      title: "Size",
      dataIndex: "size",
      key: "size",
      width: 80,
      sorter: true,
      render: (text) => <Text strong>{text}</Text>,
    },
    {
      title: "Barcode",
      dataIndex: "barcode",
      key: "barcode",
      width: 200,
      sorter: true,
      render: (text) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            padding: "4px 8px",
            border: "1px solid #d9d9d9",
            borderRadius: "4px",
            backgroundColor: "#fafafa",
          }}
        >
          <Text code style={{ fontSize: "12px", flex: 1 }}>
            {text}
          </Text>
          <CopyOutlined
            style={{
              cursor: "pointer",
              color: "#1890ff",
              fontSize: "12px",
            }}
            onClick={() => handleCopyBarcode(text)}
            title="Copy barcode"
          />
        </div>
      ),
    },
  ];

  return (
    <div style={{ width: "80vw" }}>
      <Spin spinning={loading}>
        <Table
          columns={columns}
          dataSource={data}
          onChange={handleTableOnChange}
          rowKey={(record) =>
            record.barcode || `${record._id}-${record.colorCode}-${record.size}`
          }
          pagination={pagination || { pageSize: 10 }}
          scroll={{ x: "max-content" }}
        />
      </Spin>
    </div>
  );
};

BarcodeTable.propTypes = {
  data: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  pagination: PropTypes.object,
  onPaginationChange: PropTypes.func,
  callReFetch: PropTypes.func,
  dispatch: PropTypes.func,
};

export default BarcodeTable;
